import { useCallback, useState } from "react";

const STORAGE_KEY = "staff-ui:cms-source-panel-open";

function readStored(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function writeStored(open: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(open));
  } catch {
    return;
  }
}

/** Open state of the source data panel, persisted per browser. Starts collapsed. */
export function useSourcePanelOpen(): {
  open: boolean;
  toggle: () => void;
  setOpen: (open: boolean) => void;
} {
  const [open, setOpenState] = useState(readStored);

  const setOpen = useCallback((next: boolean) => {
    setOpenState(next);
    writeStored(next);
  }, []);

  const toggle = useCallback(() => {
    setOpenState(prev => {
      writeStored(!prev);
      return !prev;
    });
  }, []);

  return { open, toggle, setOpen };
}
